import {
  Box, Image, LoadingBubbles, Text,
} from '@domain-group/suit-theme'

import styles from './styles.module.scss'

type CanvaTemplate = {
  id: string,
  title: string,
  view_url: string,
  create_url: string,
  thumbnail: {
    width: number,
    height: number,
    url: string,
  },
  created_at: number,
  updated_at: number,
}

type CanvaTemplatePageProps = {
  callbacks: {
    selectTemplate: (template: CanvaTemplate) => void,
  },
  isDisabled: boolean,
  isLoading: boolean,
  template: CanvaTemplate,
}

const CanvaTemplatePage = (props: CanvaTemplatePageProps) => {
  const {
    callbacks: { selectTemplate },
    isDisabled,
    isLoading,
    template: {
      id,
      title,
      thumbnail: { url: thumbnailUrl },
    },
    template,
  } = props

  const handleSelectTemplate = () => {
    if (isDisabled){
      return
    }

    selectTemplate(template)
  }

  return (
    <Box className={`${styles.root} ${isDisabled ? styles.disabled : ''}`} flexDirection="column">
      <Box
        alignItems="center"
        className={styles.previewContainer}
        height={190}
        justifyContent="center"
        onClick={handleSelectTemplate}
        position="relative"
        variant="whiteGrey"
      >
        {isLoading && (
          <Box
            alignItems="center"
            backgroundColor="rgba(255, 255, 255, 0.7)"
            bottom="0"
            display="flex"
            justifyContent="center"
            left="0"
            position="absolute"
            right="0"
            top="0"
          >
            <LoadingBubbles color="blue" />
          </Box>
        )}

        <Image
          backgroundSize="contain"
          height="100%"
          url={thumbnailUrl}
          width="100%"
        />
      </Box>

      <Box flexDirection="column" marginTop="medium">
        <Text fontSize="small">{title}</Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          Template #{id}
        </Text>
      </Box>
    </Box>
  )
}

export default CanvaTemplatePage
